import {AssetXMPPacketStatus, type IAsset} from './schema';

// what a monster...
export const assetDefaults: Readonly<Omit<IAsset, 'assetId'>> = {
	alphaChannel: '',
	attributeIds: [],
	attributeNames: [],
	attributeValues: [],
	attributePermissions: [],
	audioBitRate: 0,
	audioChannelCount: 0,
	audioChannelLayout: '',
	audioSampleRate: 0,
	bitDepth: 0,
	categories: [],
	categoryid: 0,
	categoryPaths: [],
	checkout: 0,
	checkoutUserLabel: '',
	colorProfile: '',
	commitAttributes: false,
	constituentType: '',
	constituentIds: [],
	creationdate: '',
	dpi: 0,
	duration: 0,
	expirationDate: 0,
	file: '',
	fileFormatFamily: [],
	fileheight: 0,
	filesize: 0,
	filetypelabel: '',
	filewidth: 0,
	fileSize2: 0,
	filetype: 0,
	flvPreview: false,
	geoLocationLabel: '',
	hidden: 0,
	iiifManifestUrl: '',
	importDate: '',
	importUserLabel: '',
	inCurrentCart: false,
	latitude: 0.0,
	locationContext: '',
	locationid: 0,
	longitude: 0.0,
	md5sum: '',
	moduserid: 0,
	moduserlabel: '',
	metadataAvailable: false,
	moddate: '',
	name: '',
	path: '',
	permissionMatrix: [1, 1, 1, 1, 1, 1],
	proofAvailable: false,
	previewUrl: '',
	previewHeight: 0,
	previewWidth: 0,
	rating: 0,
	readOnly: 0,
	relatedAvailable: false,
	repurposeAvailability: 0,
	reviewAvailable: false,
	status: 0,
	statDeliveries: 0,
	statPreviews: 0,
	template: false,
	templatable: false,
	templateCustomizable: false,
	thumb: '',
	thumbUrl: '',
	timeScale: 0,
	versionIds: [],
	viewIds: [],
	viewNames: [],
	visible: 1,
	xmpPacketStatus: AssetXMPPacketStatus.NOT_STORED_NO_XMP,
	zoomAvailable: false,

	// Deprecated fields -- do not use!
	attribute1: '',
	attribute2: '',
	attribute3: '',
	attribute4: '',
	attribute5: '',
	attribute6: '',
	attribute7: '',
	attribute8: '',
	attribute9: '',
	attribute10: '',
	attribute11: '',
	attribute12: '',
	attribute13: '',
	attribute14: '',
	attribute15: '',
	attribute16: '',
	hasChildren: false,
	imageid: 0,
	metadata: '',
	parentId: 0,
};
